import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ganesh-chaturthi',
  templateUrl: './ganesh-chaturthi.component.html',
  styleUrls: ['./ganesh-chaturthi.component.scss']
})
export class GaneshChaturthiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
